import { useQuery } from '@tanstack/react-query';
import {
  client,
  INDEX_NAME,
} from 'src/lib/meilisearch';

/**
 * @typedef {import('src/lib/type').Suggestion} Suggestion
 */

const index = client.index(INDEX_NAME);

/**
 * Hook pour effectuer une recherche MeiliSearch avec TanStack Query
 * @param {string} query - La requête de recherche
 * @param {Object} options - Options de configuration
 * @param {boolean} options.isHybridSearchEnabled - Conserve les données précédentes pendant le rechargement
 * @param {boolean} options.enabled - Active ou désactive la requête
 */
export function useSearchQuery(query, options = {}) {
  const { enabled = true, isHybridSearchEnabled = false } = options;

  return useQuery({
    queryKey: ['search', query, { isHybridSearchEnabled }],
    queryFn: async ({ signal }) => {
      
      const searchResults = await index.search(
        query,
        {
          limit: 20,
          attributesToHighlight: ['title', 'searchField'],
          attributesToCrop: ['searchField'],
          cropLength: 40,
          cropMarker: '…',
          ...(isHybridSearchEnabled && {
            hybrid: {
              semanticRatio: 0.8,
              embedder: 'OpenAI',
            },
          }),
        },
        {
          signal,
        }
      );
      
      /** @type {import('src/lib/type').SearchHit[]} */
      const hits = searchResults.hits;

      return hits;
    },
    enabled: enabled && !!query && query.trim().length > 0,
    keepPreviousData: true,
  });
}
